import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=38444dfd&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=38444dfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38444dfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38444dfd')) {
      api.createRecord('38444dfd', component.options)
    } else {
      api.reload('38444dfd', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=38444dfd&scoped=true&", function () {
      api.rerender('38444dfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2N8wOl4QNak5Y/JS/comp/PopupBox.vue"
export default component.exports